'use client';

/**
 * Settings pending navigation — thin re-export of the shared route store.
 * Prefer `~/components/Navigation/routeNavigationStore` for new call sites.
 */
export {
  setPendingHref as setSettingsPendingHref,
  usePendingHref as useSettingsPendingHref,
  markPendingNavigation,
} from '~/components/Navigation/routeNavigationStore';
